"use strict";

define('rs/form/formobjects/textarea/textarea.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/textarea/textarea.formobject.view'], function (BaseFormObject, TextAreaFormObjectView) {
  var TextAreaFormObject = BaseFormObject.extend({
    properties: ['rich'],
    propertiesDefinitions: ['name', 'required', 'label', 'text', 'description', 'helpText'],
    linksDefinitions: ['link.displayed', 'link.required'],
    rich: true,
    isAnswerable: true,
    setupView: function setupView() {
      this.setView(new TextAreaFormObjectView());
    },
    getTextOnlyValue: function getTextOnlyValue() {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = this.getValue() || '';
      return tmp.textContent || tmp.innerText || "";
    },
    checkValue: function checkValue() {
      return !!this.getTextOnlyValue();
    },
    isRich: function isRich() {
      return !!this.getRich();
    },
    getCompareValue: function getCompareValue() {
      return this.getValue() || '';
    }
  }, {
    getTypeString: function getTypeString() {
      return 'TextArea';
    }
  });
  return TextAreaFormObject;
});

